import React, { useMemo, useState, useCallback } from "react";

import IconButton from "@mui/material/IconButton";

import Dialog, { DialogTitle, DialogActions } from "components/common/Dialog";
import TableComponent from "components/common/TableComponent";
import Button from "components/common/Button";

import { downloadLeaveDocument } from "services/useTimeoffService";
import { getFileSizeToDisplay } from "util/utils";

import {
  PictureAsPdfOutlined as PictureAsPdfOutlinedIcon,
  InsertPhotoOutlined as InsertPhotoOutlinedIcon,
  FileDownloadOutlined as FileDownloadOutlinedIcon,
} from "@mui/icons-material";

import "./DocumentsViewModal.scss";

function getFileIcon(extension) {
  if (extension === ".pdf") {
    return <PictureAsPdfOutlinedIcon className="color-icon-primary mr-05" />;
  }
  return <InsertPhotoOutlinedIcon className="color-icon-primary mr-05" />;
}

function DocumentsViewModal({ showDocumentsViewModal, setShowDocumentsViewModal, documents, employeeId }) {
  const [downloadingId, setDownloadingId] = useState(null);

  const handleClose = () => {
    setShowDocumentsViewModal(false);
  };

  const handleDownload = useCallback(
    async (documentId, name) => {
      if (!documentId || downloadingId) return;

      try {
        setDownloadingId(documentId);
        await downloadLeaveDocument(documentId, name, employeeId);
      } finally {
        setDownloadingId(null);
      }
    },
    [downloadingId]
  );

  const columns = useMemo(
    () => [
      {
        id: "name",
        label: "Name",
        render: (_, row) => (
          <span className="document-row ml-1" title={row.name}>
            {getFileIcon(row.extension)}
            {row.name.slice(0, 50)}
          </span>
        ),
      },
      {
        id: "size",
        label: "Size",
        render: (_, row) => <p>{getFileSizeToDisplay(row.size)}</p>,
      },
      {
        id: "action",
        label: "",
        align: "right",
        render: (_, row) => (
          <IconButton size="small" disabled={downloadingId === row.documentId}>
            <FileDownloadOutlinedIcon
              className="download-btn"
              onClick={() => handleDownload(row.documentId, row.name)}
            />
          </IconButton>
        ),
      },
    ],
    [downloadingId, handleDownload]
  );

  return (
    <Dialog
      open={showDocumentsViewModal}
      onClose={handleClose}
      title={<DialogTitle title="Documents" />}
      content={
        <div className="documents-view-modal-content">
          <TableComponent tableHeadSmall noCellPadding columns={columns} data={documents} disableSort />
        </div>
      }
      actions={
        <DialogActions
          action1={
            <Button
              variant="contained"
              onClick={handleClose}
              isDisabled={false}
              isLoading={false}
              className="text-blue-600"
              label="Done"
              size="large"
            />
          }
        />
      }
      size="sm"
    />
  );
}

export default DocumentsViewModal;
